var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseradd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_946_4247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8752 34.3722H65.6251V28.1221C65.6251 26.3963 64.2261 24.9972 62.5002 24.9972C60.7743 24.9972 59.3752 26.3963 59.3752 28.1221V34.3722H53.1252C51.3993 34.3722 50.0002 35.7712 50.0002 37.4971C50.0002 39.223 51.3993 40.6221 53.1252 40.6221H59.3752V46.8721C59.3752 48.598 60.7743 49.997 62.5002 49.997C64.2261 49.997 65.6251 48.598 65.6251 46.8721V40.6221H71.8752C73.6011 40.6221 75.0001 39.223 75.0001 37.4971C75.0001 35.7712 73.6011 34.3722 71.8752 34.3722Z",
    fill: "#1E3F76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125 37.5C38.4803 37.5 46.875 29.1053 46.875 18.75C46.875 8.39466 38.4803 0 28.125 0C17.7697 0 9.375 8.39466 9.375 18.75C9.375 29.1053 17.7697 37.5 28.125 37.5Z",
    fill: "#1E3F76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125 43.7471C12.5991 43.7644 0.0172852 56.3463 0 71.8721C0 73.598 1.39907 74.9971 3.12495 74.9971H53.1249C54.8508 74.9971 56.2499 73.598 56.2499 71.8721C56.2327 56.3463 43.6509 43.7643 28.125 43.7471Z",
    fill: "#1E3F76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_946_4247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseradd);
export default __webpack_public_path__ + "static/media/useradd.b9292498920675fe2c58eed42ee4b2a1.svg";
export { ForwardRef as ReactComponent };